import type { NodeChange, XYPosition } from 'reactflow';

export interface GroupUnitDrag {
  groupId: string;
  childId: string;
  childStart: XYPosition;
  parentStart: XYPosition;
  dragged: boolean;
}

/**
 * While a group is selected, keep the group selected and move the parent
 * instead of the child that received the pointer.
 */
export function rewriteGroupUnitDragChanges(
  changes: NodeChange[],
  hold: GroupUnitDrag,
): { changes: NodeChange[]; dragged: boolean } {
  let dragged = hold.dragged;
  const next: NodeChange[] = [];
  for (const change of changes) {
    if (change.type === 'select' && (change.id === hold.groupId || change.id === hold.childId)) {
      continue;
    }
    if (change.type === 'position' && change.id === hold.childId) {
      if (change.position) {
        dragged = true;
        next.push({
          type: 'position',
          id: hold.groupId,
          dragging: change.dragging,
          position: {
            x: hold.parentStart.x + (change.position.x - hold.childStart.x),
            y: hold.parentStart.y + (change.position.y - hold.childStart.y),
          },
        });
      } else {
        next.push({
          type: 'position',
          id: hold.groupId,
          dragging: change.dragging,
        });
      }
      continue;
    }
    next.push(change);
  }
  return { changes: next, dragged };
}
